<template>
  <div class="main">
    <report-top>
      <ly-search slot="search" v-model="searchItem.keyword" @search="search"></ly-search></report-top>
    <selectTool ref="selectTool"><template slot="btn"><Button @click="getSearchItem" type="error"
          class="chaxun">查询</Button><Button @click="openAdd" type="primary" class="chaxun">新增</Button></template>
    </selectTool>

    <Table border :columns="columns" :data="tableData" no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)">
      <AddressList slot-scope="{ row, index }" slot="addressS" :list="row.addressS" :readonly="true" :noUpdate="true">
      </AddressList>
      <AddressList slot-scope="{ row, index }" slot="addressD" :list="row.addressD" :readonly="true" :noUpdate="true">
      </AddressList>

      <template slot-scope="{ row, index }" slot="action">
        <!-- <Button size="small" @click="openUpdateStatus(row, index)">提货</Button> -->
        <Button size="small" @click="openUpdateDispatchStatus(row, index)">调度</Button>
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page :current="1" :total="total" :page-size="searchItem.pageSize" :page-size-opts="[10, 50, 100]" show-total
          show-elevator show-sizer @on-change="changePage" @on-page-size-change="pageSizeChange"></Page>
      </div>
    </div>
    <form-model @selectCar="carNoChange" @reset="reset" :oldItem="oldItem" :title="isAdd ? '新增数据' : '编辑数据'" width="1000" ref="formModel">
      <alot-item @on-click="openForm = true" slot="ono" v-model="item.listOrders" keyw="ono"
        style="min-height: 30px"></alot-item>
      <stations ref="stations" slot="stations"></stations>
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
    <form-model title="更新提货状态" width="400" ref="updateStatus">
      <Button slot="btn" type="primary" @click="updateStatus">提交表单</Button>
    </form-model>
    <form-model title="更新调度状态" width="400" ref="updateDispatchStatus">
      <Button slot="btn" type="primary" @click="updateDispatchStatus">提交表单</Button>
    </form-model>
    <Modal v-model="openForm" fullscreen title="订单号" footer-hide width="1000">
      <dingdanhao :scan="true" :checkMore="true" :status="[]" @objs="reObj" :col="col" v-if="openForm"></dingdanhao>
    </Modal>
  </div>
</template>

<script>
var ordes = [];
var list1 = [],
  list2 = [];
//pickupTime
import dingdanhao from "./xitongkaidanLianhe.vue";
import stations from "./stations.vue";
//
list2 = [];
export default {
  components: { dingdanhao, stations },
  data() {
    return {
      isAdd: false,
      openForm: false,
      openChuhuo: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
          sort: 0,
        },
        /* {
          title: "提货状态",
          key: "status2", //0--/未入仓 1--已入仓
          sort: 1.1,
        }, */
        {
          title: "调度单号",
          key: "no",
          sort: 1.1,
        },
        {
          title: "调度状态",
          key: "dispatchStatus2", //0--/待提货 1--已调度
          sort: 1.2,
        },
        {
          title: "操作",
          slot: "action",
          sort: 100,
          width: 150,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        xd: 0,
        xs: 0,
        yd: 0,
        ys: 0,
        groupId: "",
        groupName: "",
        no: "",
        listOrders: [],
        addressPort: "",
        carNo: "",
        carNoHk: "",
        bpMode: 0,
        carType: "",
        driverAccount: "",
        driver: "",
        driverAccountHk: "",
        driverHk: "",
        addressS: [],
        timeS: Date.now(),
        timesUnload: Date.now() + 3600000 * 2,
        addressD: [],
        remark: "",
        lineMarkList: [],
        freightHouse:''
        //extendFields: "",
      },
      forms: [
        /* {
          title: "提货单号",
          key: "no",
          required: false,
          type: "Select",
          selectItems: ["HS202305061112"],
        }, */
        {
          title: "订单号",
          key: "listOrders",
          key2: "listOrders2",
          slotForm: "ono",
          required: true,
          span: 24,
        },
        {
          title: "运输线路",
          slotForm: "stations",
          noTable: true,
          span: 24,
        },
        {
          title: "业务类型",
          key: "bpMode",
          key2: "bpMode2",
          type: "Select",
          selectType: "obj",
          selectItems: this.lydic["bpMode"],
          span: 6,
        },
        {
          title: "大陆车牌",
          key: "carId",
          key1: "carNo",
          required: false,
          isHand: true,
          clearable: true,
          type: "selectCar",
          span: 6,
        },
        {
          title: "大陆司机",
          key4: "driverAccount",
          key1: "driver",
          clearable: true,
          isHand: true,
          required: false,
          type: "selectUser",
          span: 6,
          keyword: "司机",
        },
        {
          title: "香港车牌",
          key: "carIdHK",
          key1: "carNoHk",
          required: false,
          isHand: true,
          readonly: true,
          clearable: true,
          type: "selectCar",
          span: 6,
        },
        {
          title: "香港司机",
          key4: "driverAccountHk",
          key1: "driverHk",
          clearable: true,
          isHand: true,
          required: false,
          type: "selectUser",
          span: 8,
          keyword: "司机",
        },
        {
          title: "交接口岸",
          key: "addressPort",
          required: false,
          type: "Select",
          selectItems: this.lydic.getA("port"),
          span: 8,
        },
        {
          title: "卸货仓",
          key: "freightHouse",
          type: "Input",
          span: 8,
        },

        /*  {
           title: "提货地点",
           key: "addressS",
           keyX: "xs",
           keyY: "ys",
           slot: "addressS",
           required: true,
           readonly: false,
           noUpdate: true,
           width: 300,
           type: "AddressList",
           span: 8,
           list1,
           list2,
         },
         {
           title: "卸货地点",
           key: "addressD",
           slot: "addressD",
           keyX: "xd",
           keyY: "yd",
           width: 300,
           required: true,
           readonly: false,
           noUpdate: true,
           type: "AddressList",
           span: 8,
           list1,
           list2,
         }, */
        {
          title: "提货时间",
          key: "timeS",
          key2: "timeS2",
          required: true,
          type: "lyyymmdd",
          formate: "datetime",
          span: 8,
        },
        {
          title: "卸货时间",
          key: "timesUnload",
          key2: "timesUnload2",
          required: true,
          type: "lyyymmdd",
          formate: "datetime",
          span: 8,
        },

        {
          title: "装货到场时间",
          key: "timesLoadArrive",
          key2: "timesLoadArrive2",
          type: "lyyymmdd",
          formate: "datetime",
          span: 8,
        },
        {
          title: "装货离开时间",
          key: "timesLoadLeave",
          key2: "timesLoadLeave2",
          type: "lyyymmdd",
          formate: "datetime",
          span: 8,
        },
        {
          title: "卸货到场时间",
          key: "timesUnloadArrive",
          key2: "timesUnloadArrive2",
          type: "lyyymmdd",
          formate: "datetime",
          span: 8,
        },
        {
          title: "卸货离开时间",
          key: "timesUnloadLeave",
          key2: "timesUnloadLeave2",
          type: "lyyymmdd",
          formate: "datetime",
          span: 8,
        },
        {
          title: "备注",
          key: "remark",
          required: false,
          type: "Input",
          span: 8,
        },
      ],
      updateStatusItem: {
        status: 0,
        no: "",
      },
      updateStatusForms: [
        {
          title: "提货状态",
          key: "status",
          type: "Select1",
          st: "rucang",
          required: true,
        },
      ],
      updateDispatchStatusItem: {
        no: "",
        dispatchStatus: "",
      },
      updateDispatchStatusForms: [
        {
          title: "调度状态",
          key: "dispatchStatus",
          type: "Select",
          selectType: "obj",
          selectItems: this.lydic["dispatchStatus"],
          required: true,
        },
      ],
      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
      },
      total: 0,

      searchForms: [
        {
          title: "六联单号",
          key: "sixOno",
          type: "Input",
        },
        {
          title: "订单号",
          key: "ono",
          type: "Input",
        },
        {
          title: "调度单号",
          key: "no",
          type: "Input",
        },
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          required: true,
          val: 0,
          type: "lyyymmdd",
          times: "4,2,0",
        },
      ],

      col: [
        {
          title: "订单编号",
          minWidth: 180,
          key: "ono",
          tree: true,
          sort: 0,
        },
        {
          title: "创建时间",
          minWidth: 180,
          key: "createTime2",
          tree: true,
          sort: 0.1,
        },
        {
          title: "订单状态",
          minWidth: 130,
          key: "status2",
          sort: 0,
        },
        {
          title: "始发地",
          key: "addressS",
        },
        {
          title: "目的地",
          key: "addressD",
        },
        {
          title: "进出口岸",
          key: "customs",
        },

        {
          title: "业务类型",
          key: "bpMode2",
        },
        {
          title: "车辆类型",
          key: "carType",
        },
        {
          title: "客户名称",
          key: "customer",
        },
        {
          title: "开单员",
          key: "creator",
        },
        {
          title: "备注信息",
          key: "remark",
        },
        {
          title: "提货地址",
          slot: "pickupAddress",
          width: 300,
        },
        {
          title: "卸货地址",
          slot: "unloadAddress",
          width: 300,
        },
      ],
      oldItem:{}
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        //url: this.axios.ipPort + "/cloud-tms-server-ctc/pickup/list",
        url: this.axios.ipPort + "/cloud-tms-server-ctc/pickup/listDispatch",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i].dispatchStatus2 = this.lydic.getVal(
            "dispatchStatus",
            data[i].dispatchStatus
          );
          data[i].status2 = this.$t("rucang." + data[i].status);
          data[i].timeS2 = this.utils.time(data[i].timeS, "yymmddhhmm");
          data[i].timesUnload2 = this.utils.time(
            data[i].timesUnload,
            "yymmddhhmm"
          );
          data[i].timesLoadArrive2 = this.utils.time(
            data[i].timesLoadArrive,
            "yymmddhhmm"
          );
          data[i].timesLoadLeave2 = this.utils.time(
            data[i].timesLoadLeave,
            "yymmddhhmm"
          );
          data[i].timesUnloadArrive2 = this.utils.time(
            data[i].timesUnloadArrive,
            "yymmddhhmm"
          );
          data[i].timesUnloadLeave2 = this.utils.time(
            data[i].timesUnloadLeave,
            "yymmddhhmm"
          );
          data[i].listOrders2 = ordes(data[i].listOrders);
          data[i].bpMode2 = this.lydic.getVal("bpMode", data[i].bpMode);
          //data[i].pickupAddress = pick(data[i].ordersGoodsList);
          // data[i].unloadAddress = unLoad(data[i].ordersUnGoodsList);
        }
        this.tableData = data;
        function ordes(t) {
          var arr = [];
          for (let i = 0; i < t.length; i++) {
            arr.push(t[i].ono);
          }

          return arr.join(",");
        }
      });
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      this.item.lineMarkList = this.$refs.stations.getVal();
      if (this.utils.isEmpty(this.item.lineMarkList)) {
        this.$Message.error('运输线路必填');
        return;
      }

      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-ctc/pickup/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-ctc/pickup/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    reset(v) {    
      setTimeout(() => {
        this.item.listOrders=[];

        this.$refs.stations.reach([], [], []);
      }, 200);
      //
    },
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.ipPort + "/cloud-tms-server-ctc/pickup/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      //this.item = JSON.parse(JSON.stringify(row));
      for (const i in this.item) {
        this.item[i] = row[i];
      }
      this.item.id = row.id;
      //将路线的点回填到提货卸货等选项
      var tt = this.item.lineMarkList;
      var addressS = [],
        addressD = [],
        kouan = [];
      for (let i = 0; i < tt.length; i++) {
        if (tt[i].action == "提货") {
          addressS.push(tt[i]);
        } else if (tt[i].action == "途经") {
          kouan.push(tt[i]);
        } else if (tt[i].action == "卸货") {
          addressD.push(tt[i]);
        }
      }
      this.$refs.formModel.reach(this.forms, this.item);
      setTimeout(() => {
        this.$refs.stations.reach(addressS, addressD, kouan);
      }, 200);
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
      this.$refs.formModel.resetForm();
    },
    openUpdateStatus(row) {
      this.updateStatusItem.no = row.no;
      this.updateStatusItem.status = row.status;
      this.$refs.updateStatus.reach(
        this.updateStatusForms,
        this.updateStatusItem
      );
    },
    updateStatus(name) {
      var a = this.$refs.updateStatus.getItem();

      if (!a) {
        return;
      }
      this.updateStatusItem = a;
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-ctc/pickup/updateStatus",
        data: this.updateStatusItem,
      }).then((res) => {
        if (res) {
          this.$refs.updateStatus.close();
          this.getList();
        }
      });
    },
    openUpdateDispatchStatus(row) {
      this.updateDispatchStatusItem.no = row.no;
      this.updateDispatchStatusItem.dispatchStatus = row.dispatchStatus;
      this.$refs.updateDispatchStatus.reach(
        this.updateDispatchStatusForms,
        this.updateDispatchStatusItem
      );
    },
    updateDispatchStatus(name) {
      var a = this.$refs.updateStatus.getItem();

      if (!a) {
        return;
      }
      this.updateStatusItem = a;
      this.axios({
        method: "post",
        url:
          this.axios.ipPort +
          "/cloud-tms-server-ctc/pickup/updateDispatchStatus",
        data: this.updateDispatchStatusItem,
      }).then((res) => {
        if (res) {
          this.$refs.updateDispatchStatus.close();
          this.getList();
        }
      });
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    //carTypeCategory
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
    reObj(v) {
      this.openForm = false;
      //this.item.listOrders = [];

      this.item.listOrders = [];
      var addressS = [];
      var addressD = [];
      var kouan = [];
      var konanText=[];//做判断用的
      var kouans = [
        {
          id: "kouan1",
          address: "深圳湾",
          name: "深圳湾",
          x: 113.95,
          y: 22.50,
          radius: 500,
          action: "途经",
        },
        {
          id: "kouan2",
          address: "皇岗",
          name: "皇岗",
          x: 114.07,
          y: 22.52,
          radius: 500,
          action: "途经",
        },
        {
          id: "kouan3",
          address: "文锦渡",
          name: "文锦渡",
          x: 114.13,
          y: 22.54,
          radius: 500,
          action: "途经",
        },
        {
          id: "kouan4",
          address: "莲塘",
          name: "莲塘",
          x: 114.16,
          y: 22.55,
          radius: 500,
          action: "途经",
        },
        {
          id: "kouan5",
          address: "沙头角",
          name: "沙头角",
          x: 114.23,
          y: 22.55,
          radius: 500,
          action: "途经",
        },
      ];
      for (let i = 0; i < v.length; i++) {
        this.item.listOrders.push({ ono: v[i].ono });
        if (!konanText.includes(v[i].customs)) {
          //口岸，匹配添加经纬度
          for (let r = 0; r < kouans.length; r++) {
            if (v[i].customs == kouans[r].name) {
              kouan.push(kouans[r]);
              konanText.push(kouans[r].name);
            }
          }
        }


        var t = v[i].unloadAddress;
        for (let j = 0; j < t.length; j++) {
          t[j].action = "卸货";
          addressD.push(t[j]);
        }
      }
      //获取最新的提货点

      //去重

      var arr = addressD;
      addressD = addressD.filter(
        (item, index) => addressD.findIndex((i) => i.x === item.x) === index
      );
      //this.item.addressS = addressS;
      //this.item.addressD = addressD;
      if (kouan.length == 1) {
        this.item.addressPort = kouan[0].name;
      } else {
        alert("请注意，您选择了多个口岸");
      }
      this.getLastDispatch(addressD, kouan);
    },
    getKehuItem() {
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-base/customer/info",
        data: { id: this.item.cid },
      }).then((res) => {
        var pickupAddressList = res.data.data.pickupAddressList;
        var shippingAddressList = res.data.data.shippingAddressList;
        list1.splice(0, 1000);
        list2.splice(0, 1000);
        for (let i = 0; i < pickupAddressList.length; i++) {
          var add = pickupAddressList[i].address.split("_");

          var obj = {
            name: add[0],
            address: add[1],
            x: pickupAddressList[i].x,
            y: pickupAddressList[i].y,
          };
          list1.push(obj);
        }
        for (let i = 0; i < shippingAddressList.length; i++) {
          var add = shippingAddressList[i].address.split("_");
          var obj = {
            name: add[0],
            address: add[1],
            x: shippingAddressList[i].x,
            y: shippingAddressList[i].y,
          };
          list2.push(obj);
        }
      });
    },
    getLastDispatch(addressD, kouan) {
      var ordes = this.item.listOrders;
      var addressS = [];
      this.utils.loading(this, "加载中");
      for (let i = 0; i < ordes.length; i++) {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-ctc/pickup/lastDispatch",
          data: { ono: ordes[i] },
        }).then((res) => {

          var data = res.data.data.addressS;

          addressS = addressS.concat(data);
          if (i == ordes.length - 1) {
            this.$Spin.hide(); //关闭加载
            addressS = addressS.filter(
              (item, index) => addressS.findIndex((i) => i.x === item.x) === index
            );
            for (let m = 0; m < addressS.length; m++) {
              addressS[m].action = "提货";
            }
            this.$refs.stations.reach(addressS, addressD, kouan);
          }

        });

      }

    },
    chuhuo(row) {
      this.openChuhuo = true;
      this.$refs.chuhuo.reach(row);
    },
    carNoChange(v) {
      var c = v.carNo.split('/');
      this.item.carNo = c[0];
      if (c.length == 2) {
        this.item.carNoHk = c[1];
      } else {
        this.item.carNoHk = '';
      }

    }
  },
  mounted() {
    var config = {
      min: 130,
      max: 300,
    };
    this.columns = this.utils.cols(this.forms, this.columns, config);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 300);
    this.oldItem=JSON.parse(JSON.stringify(this.item))
  },

};
</script>

<style></style>


// WEBPACK FOOTER //
// src/components/wuliu/fahuo/shangmentihuo.vue